class CookieBanner extends HTMLElement {
  panelConsent = null;
  panelDetails = null;
  tabConsent = null;
  tabDetails = null;
  consentApiReady = false;
  constructor() {
    super();
    this.showConsentTab = this.showConsentTab.bind(this);
    this.showDetailsTab = this.showDetailsTab.bind(this);
    this.initSyncedCheckboxes = this.initSyncedCheckboxes.bind(this);
    this.initConsentApis = this.initConsentApis.bind(this);
    this.bindActionButtons = this.bindActionButtons.bind(this);
    this.handleAllowAll = this.handleAllowAll.bind(this);
    this.handleAllowSelected = this.handleAllowSelected.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.applyConsent = this.applyConsent.bind(this);
    this.getSelections = this.getSelections.bind(this);
    this.showBanner = this.showBanner.bind(this);
    this.hideBanner = this.hideBanner.bind(this);
    this.ensureGtag = this.ensureGtag.bind(this);
    this.getOverlay = this.getOverlay.bind(this);
    this.restoreSelections = this.restoreSelections.bind(this);
  }
  async connectedCallback() {
    this.tabConsent = this.querySelector("#tab-consent");
    this.tabDetails = this.querySelector("#tab-details");
    this.panelConsent = this.querySelector("#panel-consent");
    this.panelDetails = this.querySelector("#panel-details");
    if (this.tabConsent) this.tabConsent.addEventListener("click", this.showConsentTab);
    if (this.tabDetails) this.tabDetails.addEventListener("click", this.showDetailsTab);
    await this.initConsentApis();
    this.showConsentTab();
    this.initSyncedCheckboxes();
    const showBanner = await this.checkConsentBannerInteraction();
    if (!showBanner) {
      this.seedSelectionsFromHtmlIfFirstVisit();
      await this.restoreSelections();
    }
    this.bindActionButtons();
    const recall = document.getElementById("recall-consent-banner");
    if (recall) {
      recall.addEventListener("click", (event) => {
        event.preventDefault();
        this.showBanner();
      });
    }
    if (showBanner) this.showBanner();
  }
  async checkConsentBannerInteraction() {
    const saved = localStorage.getItem("cookieSelections");
    console.log("[CookieBanner] checkConsentBannerInteraction - localStorage:", saved);
    if (saved) return false;
    if (!this.consentApiReady || !window.Shopify?.customerPrivacy?.currentVisitorConsent) {
      return true;
    }
    try {
      const visitorConsent = await window.Shopify.customerPrivacy.currentVisitorConsent();
      const empty = (visitorConsent.preferences ?? "") === "" && (visitorConsent.analytics ?? "") === "" && (visitorConsent.marketing ?? "") === "";
      return empty;
    } catch {
      return true;
    }
  }
  showConsentTab() {
    if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
      this.panelConsent.classList.remove("tw:hidden!");
      this.panelConsent.classList.add("active");
      this.panelDetails.classList.add("tw:hidden!");
      this.panelDetails.classList.remove("active");
      this.tabConsent.classList.add("active");
      this.tabDetails.classList.remove("active");
    }
  }
  showDetailsTab() {
    if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
      this.panelConsent.classList.add("tw:hidden!");
      this.panelConsent.classList.remove("active");
      this.panelDetails.classList.remove("tw:hidden!");
      this.panelDetails.classList.add("active");
      this.tabConsent.classList.remove("active");
      this.tabDetails.classList.add("active");
    }
  }
  initSyncedCheckboxes() {
    const all = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
    const onChange = (event) => {
      const target = event.currentTarget;
      const key = target.dataset.consent;
      if (!key) return;
      const { checked } = target;
      all.forEach((other) => {
        if (other === target) return;
        if (other.dataset.consent !== key) return;
        if (!other.disabled) other.checked = checked;
      });
    };
    all.forEach((checkbox) => checkbox.addEventListener("change", onChange));
    const byKey = /* @__PURE__ */ new Map();
    all.forEach((checkbox) => {
      const key = checkbox.dataset.consent;
      if (!byKey.has(key)) byKey.set(key, []);
      byKey.get(key).push(checkbox);
    });
    Array.from(byKey.values()).forEach((group) => {
      const source = group[0];
      group.slice(1).forEach((checkbox) => {
        if (!checkbox.disabled) checkbox.checked = source.checked;
      });
    });
  }
  async initConsentApis() {
    this.ensureGtag();
    const localStorageCookieSelections = localStorage.getItem("cookieSelections");
    console.log("Local cookie selections:", localStorageCookieSelections);
    const selections = localStorageCookieSelections ? (() => {
      try {
        return JSON.parse(localStorageCookieSelections);
      } catch {
        return { personalization: false, marketing: false, analytics: false };
      }
    })() : { personalization: false, marketing: false, analytics: false };
    console.log("Parsed local selections:", selections);
    const defaultConsent = {
      functionality_storage: "granted",
      analytics_storage: selections.analytics ? "granted" : "denied",
      personalization_storage: selections.personalization ? "granted" : "denied",
      ad_personalization: selections.personalization ? "granted" : "denied",
      ad_storage: selections.marketing ? "granted" : "denied",
      ad_user_data: selections.marketing ? "granted" : "denied",
      wait_for_update: 3e3
    };
    window.gtag?.("consent", "default", defaultConsent);
    window.gtag?.("set", "ads_data_redaction", false);
    window.gtag?.("set", "url_passthrough", true);
    this.injectGtm();
    if (!window.Shopify?.loadFeatures) return;
    await new Promise((resolve) => {
      try {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
          if (error) {
            console.error("Error loading Shopify consent-tracking-api:", error);
            resolve();
            return;
          }
          this.consentApiReady = true;
          resolve();
          document.addEventListener("visitorConsentCollected", async () => {
            try {
              const v = await window.Shopify?.customerPrivacy?.currentVisitorConsent?.();
              if (!v) return;
              this.setGroup("personalization", v.preferences === "yes");
              this.setGroup("marketing", v.marketing === "yes");
              this.setGroup("analytics", v.analytics === "yes");
              this.saveSelections();
            } catch (err) {
              console.error("visitorConsentCollected handler error:", err);
            }
          });
        });
      } catch (e) {
        console.error("loadFeatures threw:", e);
        resolve();
      }
    });
  }
  injectGtm() {
    const gtmId = this.dataset.gtmId;
    if (!gtmId) return;
    if (document.querySelector(`script[src*="${gtmId}"]`)) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  }
  // eslint-disable-next-line class-methods-use-this
  ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
  }
  bindActionButtons() {
    const allowAllBtn = this.querySelector(".allow-all-btn");
    const allowSelectedBtn = this.querySelector(".allow-selected-btn");
    const rejectBtn = this.querySelector('[data-action="reject"]');
    if (allowAllBtn) allowAllBtn.addEventListener("click", this.handleAllowAll);
    if (allowSelectedBtn) allowSelectedBtn.addEventListener("click", this.handleAllowSelected);
    if (rejectBtn) rejectBtn.addEventListener("click", this.handleReject);
  }
  handleAllowAll() {
    const shopify = {
      preferences: "yes",
      marketing: "yes",
      analytics: "yes"
    };
    const allCheckboxes = this.querySelectorAll("input.ed-checkbox[data-consent]");
    allCheckboxes.forEach((checkbox) => {
      if (!checkbox.disabled) checkbox.checked = true;
    });
    this.applyConsent(shopify, true);
  }
  handleAllowSelected() {
    const { personalization, marketing, analytics } = this.getSelections();
    const shopify = {
      preferences: personalization ? "yes" : "no",
      marketing: marketing ? "yes" : "no",
      analytics: analytics ? "yes" : "no"
    };
    this.applyConsent(shopify, true);
  }
  handleReject() {
    const shopify = {
      preferences: "no",
      marketing: "no",
      analytics: "no"
    };
    this.applyConsent(shopify, true);
  }
  seedSelectionsFromHtmlIfFirstVisit() {
    if (localStorage.getItem("cookieSelections")) return;
    const selections = {
      personalization: !!this.querySelector('input.ed-checkbox[data-consent="personalization"]')?.checked,
      marketing: !!this.querySelector('input.ed-checkbox[data-consent="marketing"]')?.checked,
      analytics: !!this.querySelector('input.ed-checkbox[data-consent="analytics"]')?.checked
    };
    console.log("[CookieBanner] SEEDING localStorage (this happens before banner check!):", selections);
    localStorage.setItem("cookieSelections", JSON.stringify(selections));
  }
  setGroup(key, checked) {
    const boxes = this.querySelectorAll(`input.ed-checkbox[data-consent="${key}"]`);
    boxes.forEach((cb) => {
      if (!cb.disabled) cb.checked = checked;
    });
  }
  async restoreSelections() {
    const raw = localStorage.getItem("cookieSelections");
    if (!raw) return;
    try {
      const selections = JSON.parse(raw);
      this.setGroup("personalization", selections.personalization);
      this.setGroup("marketing", selections.marketing);
      this.setGroup("analytics", selections.analytics);
    } catch (event) {
      console.warn("Invalid cookieSelections in localStorage; leaving HTML defaults.", event);
    }
  }
  saveSelections() {
    const selections = this.getSelections();
    localStorage.setItem("cookieSelections", JSON.stringify(selections));
  }
  getSelections() {
    const isConsentChecked = (consentType) => !!this.querySelector(`input.ed-checkbox[data-consent="${consentType}"]`)?.checked;
    return {
      personalization: isConsentChecked("personalization"),
      marketing: isConsentChecked("marketing"),
      analytics: isConsentChecked("analytics")
    };
  }
  async applyConsent(shopify, hide) {
    const google = {
      functionality_storage: "granted",
      analytics_storage: shopify.analytics === "yes" ? "granted" : "denied",
      personalization_storage: shopify.preferences === "yes" ? "granted" : "denied",
      ad_personalization: shopify.preferences === "yes" ? "granted" : "denied",
      ad_storage: shopify.marketing === "yes" ? "granted" : "denied",
      ad_user_data: shopify.marketing === "yes" ? "granted" : "denied",
      wait_for_update: 3e3
    };
    window.gtag?.("consent", "update", google);
    this.saveSelections();
    window.Shopify?.customerPrivacy?.setTrackingConsent?.({
      analytics: shopify.analytics === "yes",
      marketing: shopify.marketing === "yes",
      preferences: shopify.preferences === "yes"
    });
    if (hide) this.hideBanner();
  }
  getOverlay() {
    return this.querySelector("[data-cookie-overlay]") || this;
  }
  showBanner() {
    const element = this.getOverlay();
    element.removeAttribute("hidden");
    element.classList.remove("tw:hidden!");
  }
  hideBanner() {
    const element = this.getOverlay();
    element.classList.add("tw:hidden!");
  }
}
customElements.define("cookie-banner", CookieBanner);
